export enum BANNERS_STORAGE_KEYS {
  SMALL_PLAN_BANNER_DISMISS_KEY = 'dismissedSMALLPlanBanner',
  TRIAL_BANNER_DISMISS_KEY = 'dismissedTrialBanner',
  UPGRADE_YEARLY_DISMISS_KEY = 'dismissedUpgradeYearlyBanner',
  DOWNGRADE_BANNER_DISMISS_KEY = 'dismissedDowngradeBanner',
  PRO_PLAN_DISCOUNT_BANNER_DISMISS_KEY = 'dimissedPROPlanDiscountBanner',
  INTERVAT_INTEGRATION_BANNER_DISMISS_KEY = 'dismissedIntervatIntegrationBanner',
  BELGIUM_PEPPOL_VERIFICATION_DISMISS_KEY = 'dismissedBelgiumPeppolVerificationBanner',
  PEPPOL_ACCOUNTANT_REGISTERED_DISMISS_KEY = 'dismissedPeppolAccountantRegisteredBanner',
}
